<template>
  <v-dialog v-model="dialog" fullscreen content-class="primary" scrollable>

    <v-container class="dialog-content d-flex justify-center align-start flex-column full-height">

      <span class="titles prize-title white--text d-flex justify-center">
        {{ $t('challenge.prize_breakdown') }}
      </span>
      <v-card class="pa-5 border-radius-2 w-100 prize-card">
        <v-img
          :src="require('../../assets/img/effects/corner-badge.svg')"
          elevation="6"
          contain
          class="card-number corner-number"
          v-if="!isInitialReader"
        >
          <h1 class="number-icon-card" style="margin-top:30px; color: #ff6f3a">2</h1>
        </v-img>
        <v-container fluid class="">
          <v-row>
            <v-col cols="12" sm="6" md="3" v-for="(data, index) of informationData" :key="index" class="prize-col">
              <div class="d-flex justify-center align-center flex-column full-height prize-item">
                <span class="primary--text prize-qty">{{data.qtyQuestion}}</span>
                <span class="primary--text font-weight-bold prize-label">{{$t('challenge.you_win')}}</span>
                <img :src="data.informationImg" alt="prize image" class="mt-auto prize-img"/>
                <div class="primary white--text border-radius-1 prize-value font-weight-bold">
                  {{data.value}}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            data-cy="continue-button-prize_breakdown"
            color="secondary"
            class="px-15"
            large
            rounded
            @click="startChallenge"
          >
            {{ $t('challenge.initial_text_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- Botón sticky para móvil -->
      <div class="sticky-button-mobile">
        <v-btn
          data-cy="continue-button-prize_breakdown-mobile"
          color="secondary"
          class="px-15"
          large
          rounded
          @click="startChallenge"
        >
          {{ $t('challenge.initial_text_button') }}
        </v-btn>
      </div>

    </v-container>

  </v-dialog>
</template>

<script>
  import initialReaderValidation from '@/mixins/InitialReaderValidation'
  import { mapActions, mapState } from 'vuex'

  export default {
      name: 'PrizeBreakdown',
      props: {
          dialog: { type: Boolean, default: false },
      },
      computed: {
          ...mapState({
              course: (state) => state.userData.user.course, 
          }),
      },
      data() {
          return {
              informationData: [
                  {
                      qtyQuestion: '4',
                      // eslint-disable-next-line global-require
                      informationImg: require('@/assets/img/gamifications/20beecoins.svg'),
                      value: this.$t('challenge.win4'),
                  },
                  {
                      qtyQuestion: '3',
                      // eslint-disable-next-line global-require
                      informationImg: require('@/assets/img/gamifications/15beecoins.svg'),
                      value: this.$t('challenge.win3'),
                  },
                  {
                      qtyQuestion: '2',
                      // eslint-disable-next-line global-require
                      informationImg: require('@/assets/img/gamifications/10beecoins.svg'),
                      value: this.$t('challenge.win2'),
                  },
                  {
                      qtyQuestion: '1',
                      // eslint-disable-next-line global-require
                      informationImg: require('@/assets/img/gamifications/5beecoins.svg'),
                      value: this.$t('challenge.win1'),
                  },
              ],
          }
      },
      methods: {
          ...mapActions('challenge', [
              'setChallengeStage',
              'setReadingTime',
              'setReReadingTime',
              'resetTimers',
              'startReading'
          ]),
          startChallenge(){
              this.setChallengeStage('runChallenge')
              this.resetTimers()
              this.startReading()
          }
      },
    mixins: [initialReaderValidation]
  }
</script>

<style scoped>
  /* Contenedor general del diálogo */
  .dialog-content { 
    width: 75%; max-width: 1100px; 
    overflow-y: auto; 
    -webkit-overflow-scrolling: touch; 
    max-height: 100vh; 
    padding-bottom: 48px; /* evita corte del último botón */
    padding-top: calc(env(safe-area-inset-top, 0px) + 16px); /* evita quedar detrás del notch */
  }
  @media (max-width: 1264px){ .dialog-content { width: 90%; } }
  @media (max-width: 960px){ .dialog-content { width: 100%; padding: 0 16px 64px; } }
  @media (max-width: 600px){ .dialog-content { align-items: stretch!important; } }

  .full-height {
    height: 100%;
  }

  .full-vh-height {
      height: 100vh;
  }

  .corner-number {
    position: absolute;
    left: -40px;
    top: -30px;
    width: 7vw;
    height: 8vw;
  }

  .corner-premessage-square {
    position: absolute; 
    background-color: white; 
    left: 0px; 
    top: 0px; 
    border-radius: 0 !important; 
    box-shadow: none !important;
  }

  .bee-1 {
    position: absolute; 
    right: -40px;
    top: -50px; 
    width: 130px
  }

  .bee-2 {
    position: absolute; 
    left: 380px; 
    bottom: -45px; 
    width: 130px
  }

  .premessage-font-title {
    font-style: normal;
    font-weight: 700; 
    font-size: 44px; 
    color: #4F4870
  }

  .premessage-font-text {
    font-style: normal;
    font-weight: 400; 
    font-size: 22px; 
    color: #4F4870
  }

  /* Título adaptable */
  .prize-title {
    font-size: clamp(26px, 6vw, 40px);
    font-weight: 600;
    text-align: center;
    line-height: 1.15;
    width: 100%;
    max-width: 680px;
    margin: 0 auto 12px;
    padding: 16px 16px 12px;
    position: sticky; /* permanece visible al hacer scroll */
    top: 0;
    z-index: 10;
    background: linear-gradient(147.2deg, #514585 0%, rgba(81,69,133,0.85) 60%, rgba(81,69,133,0) 100%);
    backdrop-filter: blur(2px);
    border-radius: 8px;
  }
  @media (max-width: 600px) {
    .prize-title {
      font-size: 22px!important;
      padding: 12px 16px 8px!important;
      margin-bottom: 8px!important;
    }
  }
  @supports not ((position: sticky)) { .prize-title { position: relative; } }

  .prize-card { 
    position: relative;
    overflow: auto;
    min-height: 72vh; 
    display: flex; 
    flex-direction: column;
    background: whitesmoke !important;
  }
  @media (max-width: 960px){ .prize-card { margin-top: 20px; min-height: 78vh; } }
  @media (max-width: 600px){ 
    .prize-card { 
      min-height: auto; 
      margin-top: 0!important;
      padding: 16px!important;
    } 
  }

  /* Item de premio */
  .prize-col { display: flex; }
  .prize-item { width: 100%; min-height: 240px; padding: 16px 8px 32px; position: relative; }
  @media (max-width: 600px){ 
    .prize-col { 
      max-width: 50%!important; 
      flex: 0 0 50%!important;
    }
    .prize-item { 
      min-height: auto; 
      padding: 8px 4px 16px!important;
    } 
  }

  .prize-qty { font-size: clamp(40px, 10vw, 56px); line-height: 1; }
  .prize-label { font-size: clamp(13px, 3.2vw, 16px); text-align: center; margin-top: 4px; max-width: 150px; }
  .prize-img { max-width: 140px; width: 100%; height: auto; margin-top: 12px; }
  .prize-value { margin-top: 12px; padding: 6px 14px; font-size: clamp(12px, 3vw, 14px); line-height: 1.3; max-width: 180px; text-align: center; }
  @media (max-width: 600px){
    .prize-qty { font-size: 24px!important; }
    .prize-label { 
      font-size: 11px!important; 
      margin-top: 2px!important;
      max-width: 100px!important;
    }
    .prize-img { 
      max-width: 50px!important; 
      margin-top: 4px!important;
    }
    .prize-value { 
      max-width: 120px!important; 
      margin-top: 4px!important;
      padding: 4px 8px!important;
      font-size: 10px!important;
    }
  }

  /* Ajustes móviles para evitar overflow y dar aire al botón final */
  @media (max-width: 600px){
    .dialog-content { 
      padding-bottom: 80px; 
      align-items: stretch!important;
    }
    .prize-card { 
      padding: 16px!important; 
      margin-bottom: 20px;
    }
  }

  /* Botón sticky para móvil */
  .sticky-button-mobile {
    display: none;
  }
  
  @media (max-width: 600px) {
    .sticky-button-mobile {
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1000;
      backdrop-filter: blur(10px);
      padding: 12px 20px;
      border-radius: 50px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      width: calc(100% - 32px);
      max-width: 400px;
    }
    
    /* Ocultar completamente el botón original en móvil */
    .prize-card .v-card__actions {
      display: none!important;
    }
  }

</style>
